<template>
  <div
    @keydown.right.prevent="navigate"
    @keydown.left.prevent="navigate"
    class="component-container"
    :class="wrpClasses"
  >
    <v-btn-toggle
      :color="color"
      id="importSource"
      v-model="selectedSourceModel"
      @change="sourceSelected"
      group
      class="mt-5"
    >
      <v-btn
        value="yourPc"
        outlined
        :color="color"
        rounded
        class="importSourceButton ma-0"
        ref="pcButton"
      >
        <div class="d-flex flex-column align-center buttonContent">
          <v-icon :color="color">mdi-laptop</v-icon>
          <span class="mt-2 buttonToggleName">{{ traduceItem("yourPc") }}</span>
        </div>
      </v-btn>
      <GoogleDriveButton
        v-if="googleAppId"
        @fileSelected="fileSelectedDrive"
        @canceled="selectedSourceModel = null"
        :developerKey="googleDeveloperKey"
        :clientId="googleClientId"
        :appId="googleAppId"
        :clickIsAvailable="selectedSourceModel === 'drive'"
      >
        <v-btn
          value="drive"
          outlined
          color="primary"
          rounded
          class="importSourceButton ml-5"
          ref="driveButton"
        >
          <div class="d-flex flex-column align-center buttonContent">
            <v-img src="../../public/img/Google_Drive_logo.png"></v-img>
            <span class="mt-3 buttonToggleName">{{ $t("googleDrive") }}</span>
          </div>
        </v-btn>
      </GoogleDriveButton>
    </v-btn-toggle>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import { tools } from "../mixins/tools";
export default {
  name: "ImportSourceSelector",
  props: {
    wrpClasses: { type: Object },
    color: { type: String },
    selectedSource: { type: String },
    googleDeveloperKey: {
      type: String,
    },
    googleClientId: {
      type: String,
    },
    googleAppId: { type: String },
  },
  created() {
    this.$i18n.locale = i18n.locale;
  },
  data: () => ({
    selectedSourceModel: null,
  }),
  watch: {
    selectedSource: {
      immediate: true,
      handler(value) {
        this.selectedSourceModel = value;
      },
    },
  },
  methods: {
    sourceSelected() {
      this.$emit("sourceSelected", this.selectedSourceModel);
    },
    focusPCButton() {
      this.$nextTick(() => {
        const pcButton = this.$el.querySelector(
          '.importSourceButton[value="yourPc"]'
        );
        if (pcButton) {
          pcButton.focus();
          pcButton.classList.remove("v-btn--active");
        }
      });
    },
    fileSelectedDrive({ fileData, oauthToken }) {
      this.$emit("fileSelectedDrive", { fileData, oauthToken });
    },
    removeActiveClass() {
      [this.$refs.pcButton, this.$refs.driveButton].forEach((button) => {
        if (button && button.$el) {
          button.$el.classList.remove("v-btn--active");
        }
      });
    },
    navigate(e) {
      const buttons = [this.$refs.pcButton, this.$refs.driveButton];
      const currentIndex = buttons.findIndex(
        (button) => button && document.activeElement === button.$el
      );
      if (currentIndex === -1) return;

      let newIndex = currentIndex;
      if (e.key === "ArrowRight") {
        newIndex = (currentIndex + 1) % buttons.length;
      } else if (e.key === "ArrowLeft") {
        newIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      }
      const newButton = buttons[newIndex];
      this.removeActiveClass();
      if (
        newButton &&
        newButton.$el &&
        typeof newButton.$el.focus === "function"
      ) {
        newButton.$el.focus();
      } else {
        console.error("Focus method is not available on:", newButton);
      }
    }
  },
  mounted() {
    this.focusPCButton();
  },
  mixins: [tools],
};
</script>
<style scoped lang="scss">
::v-deep {
  #importSource .googleDrive-container {
    cursor: auto;
  }
}
#importSource {
  .importSourceButton {
    border: 1px solid var(--borderGray);
    border-radius: 10px;
    opacity: 1;
    filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.2));
    background-color: white !important;
    height: 105px;
    width: 105px;

    ::v-deep .v-btn__content {
      height: 100%;
    }

    &.v-btn--active {
      border-color: var(--primary);
    }

    &.v-btn:focus-visible {
      outline: 2px solid #9c40c7;
      outline-offset: 4px;
    }

    .buttonToggleName {
      text-transform: none;
      font-weight: 400;
      color: var(--fontColorTerciary);
      font-size: 12px;
    }
    .buttonContent {
      margin: 10px 4px 10px 4px;
      i {
        font-size: 61px;
      }
      svg {
        height: 54px;
      }
    }
  }
}

.component-container {
  &.small {
    #importSource {
      .importSourceButton {
        height: 90px;
        width: 90px;
        .buttonContent {
          i {
            font-size: 50px;
          }
          ::v-deep {
            .v-image .v-responsive__content {
              width: 50px !important;
            }
          }
          svg {
            height: 44px;
          }
          .buttonToggleName {
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>
